<template>
    <div class="automation-block-editor webhook">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.webhookURLRequired') }}</div>
            <TiptapEditor
                placeholder="URL"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.url"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.webhookMethod') }}</div>
            <CustomPicker v-model="clone.method" :items="methods" idKey="id" labelKey="label" title="Select Method" />
        </div>
        <div class="editor-row customize-editor-minimize" :key="clone.payloadType">
            <div class="editor-row-title">{{ $t('auto.webhookPayloadType') }}</div>
            <div class="btnGroup">
                <SupsisButton
                    v-for="type in ['json', 'form', 'xml', 'raw']"
                    :classNames="clone.payloadType === type ? 'btnGroupItem selected' : 'btnGroupItem '"
                    :primary="clone.payloadType === type"
                    :ghost="clone.payloadType !== type"
                    @click="() => changePayloadType(type)"
                    small
                    :key="type"
                >
                    {{ type }}
                </SupsisButton>
            </div>
            <TiptapEditor
                placeholder="Payload Type"
                :show-attributes="true"
                v-model="clone.payloadType"
                automation-mode
            />
        </div>

        <div class="editor-row customize-editor-minimize data-items">
            <div class="editor-row-title">{{ $t('auto.webhookHeaders2') }}</div>
            <DataItem
                v-for="(item, index) in clone.headers || []"
                v-model="clone.headers[index]"
                :key="index"
                @delete="() => deleteHeaderItem(index)"
            />
            <SupsisButton small ghost @click="addHeaderItem"> {{ $t('auto.webhookAddHeader') }}</SupsisButton>
        </div>

        <div class="editor-row customize-editor-minimize data-items">
            <div class="editor-row-title">{{ $t('auto.webhookData') }}</div>
            <DataItem
                v-for="(item, index) in clone.data || []"
                v-model="clone.data[index]"
                :key="index"
                @delete="() => deleteDataItem(index)"
            />
            <SupsisButton small ghost @click="addDataItem"> {{ $t('auto.webhookAddData') }}</SupsisButton>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import StringUtils from "../../../../../../../utils/StringUtils";
import DataItem from "./DataItem.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";

const log = log2("Webhook");
export default {
    name: "Webhook",
    components: { CustomPicker, DataItem, SupsisButton, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            url: null,
            payloadType: "json", //json, form,raw,xml
            wrapRequestInArray: false,
            file: null,
            data: [
                {
                    key: null,
                    value: null,
                },
            ],
        };
        return {
            clone,
            hashCode: StringUtils.hashCodeObj(clone),
            methods: ["GET", "POST", "PUT", "PATCH", "DELETE"].map((method) => ({ id: method, label: method })),
        };
    },
    methods: {
        changePayloadType(type) {
            console.log("changePayloadType", type);
            this.clone.payloadType = type;
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        addDataItem() {
            if (!this.clone.data) {
                this.clone.data = [];
            }
            this.clone.data.push({ key: null, value: null });
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        deleteDataItem(index) {
            this.clone.data.splice(index, 1);
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        addHeaderItem() {
            if (!this.clone.headers) {
                this.clone.headers = [];
            }
            this.clone.headers.push({ key: null, value: null });
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        deleteHeaderItem(index) {
            this.clone.headers.splice(index, 1);
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.hashCode = StringUtils.hashCodeObj(newValue);
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.webhook {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }

    .data-items {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .webhook-data-item {
            border-bottom: 1px solid var(--color-border-default);
            padding-bottom: 3px;
        }
    }
}
</style>
